<template>
  <material-card
    :title="$t('views.eligibility_hour_bank_evaluations_table.evaluations')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="schedule"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :showSelect="false"
      fileNamePrefix="eligibility-hour-bank-evaluations"
      identifier="pendingHourTasks"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
import getHeaders from "../headers/EligibilityBankEvaluations";

export default {
  components: {
    ErrorHandler,
  },
  mixins: [planSetter],
  data() {
    return {
      loading: false,
      item: null,
      provider: undefined,
      error: null,
      // rowActions: [
      //   {
      //     name: "components.getreports.get",
      //     icon: "file_copy",
      //     title: "Get Report",
      //     handler: getReportHandler
      //   }
      // ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getBlobAsync"
    ]),
    loadPlanData() {
      let p = new ODataProvider(
        this.$axiosHttp,
        "plans/" +
          this.selectedPlan.Id +
          "/eligibility-bank-evaluations",
        getHeaders(this.options.Enums)
      );
      this.provider = p;
    },
    async getReportHandler(item) {
      try {
        this.loading = true;
        
        const url = `plans/${this.selectedPlan.Id}/eligibility-bank-report-members-out-of-benefit/${item.Id}`;

        let blob = (await this.getBlobAsync({ url: url }))
          .data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);


        // await this.getEligibilityBankMembersDroppedOutOfBenefitsReport({
        //   planIdentityId: this.selectedPlan.Id,
        //   id: this.item.Id,
        // });
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
